<dap-lib-autocomplete
  [dataSource$]="addressSuggestions$"
  [error]="validatorService.getErrorMessage(address, validateForm)"
  [noResultsError]="'KEY_DATA.ADDRESS_SEARCH.NO_SEARCH_RESULTS' | translate"
  [formControl]="address"
  [selectedValueMapper]="selectedAddressMapper"
  [expandableDescription]="'KEY_DATA.ADDRESS_SEARCH.PICK_COMMUNITY' | translate"
  data-cy="input-address"
  inputId="address"
  label="{{ 'KEY_DATA.ADDRESS' | translate }}"
></dap-lib-autocomplete>
